// Simple compare storage util using localStorage
const STORAGE_KEY = 'dakhla_compare_items_v1';
const MAX_ITEMS = 4;

export function getCompare() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

export function saveCompare(items) {
  try {
    // Ensure each item has a stable uniqueId combining type and id
    const normalized = items.map(it => ({ ...it, uniqueId: `${it.type || 'partner'}:${it.id}` }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    // Dispatch custom event to notify listeners
    window.dispatchEvent(new CustomEvent('compareUpdated', { detail: normalized }));
  } catch (e) {
    // Silently ignore storage quota/parse errors
  }
}

export function addToCompare(item) {
  if (!item || !item.id) {
    return;
  }
  const list = getCompare();
  const uniqueId = `${item.type || 'partner'}:${item.id}`;
  // Avoid duplicates using uniqueId
  if (list.find(i => i.uniqueId === uniqueId)) {
    return;
  }
  // Limit - prevent adding more than MAX_ITEMS
  if (list.length >= MAX_ITEMS) {
    return;
  }
  const toSave = { ...item, uniqueId };
  list.push(toSave);
  saveCompare(list);
}

export function removeFromCompare(id, type) {
  if (!id) return;
  const targetUnique = type ? `${type}:${id}` : `partner:${id}`;
  const list = getCompare().filter(i => i.uniqueId !== targetUnique && i.id !== id);
  saveCompare(list);
}

export function clearCompare() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('compareUpdated', { detail: [] }));
  } catch (e) {
    // Silently ignore
  }
}

export default { getCompare, addToCompare, removeFromCompare, clearCompare };
